import { DashboardCellRendererFrame, NoValuePlaceholder, SettingsInstanceIcon } from '@aleph/shared-components';
import classNames from 'classnames';
import { FC } from 'react';
import { RedditLevel } from 'wb-reddit/app/routes/superGrid/utils';
import { noop } from 'lodash';
import SettingsBreakdownSelector from 'wb-reddit/app/routes/superGrid/cellRenderers/tool/settingsBreakdownSelector';
import useRedditClientMutator from 'wb-reddit/app/routes/superGrid/mutator/adAccount/hooks/useRedditAdClientMutator';
import useUserMetaData from 'wb-reddit/app/common/hooks/useUserMetaData';
import { userHasOneOfRoles } from 'wb-reddit/app/routes/utils';
import { UserAccountLevel } from 'wb-reddit/graphql/generated';
import { ICellRendererParams } from 'ag-grid-community';

const AdAccountSettingsCellRenderer: FC<ICellRendererParams> = (params) => {
	const { setMutatingClient } = useRedditClientMutator();
	const currentUser = useUserMetaData();

	const areSettingsAccessible = userHasOneOfRoles(currentUser, [
		UserAccountLevel.Admin,
		UserAccountLevel.Agency,
		UserAccountLevel.Advertiser,
	]) && params?.data?.level === RedditLevel.AD_ACCOUNT;

	return (
		<DashboardCellRendererFrame>
			<div
				className={
					classNames(
						'w-full flex justify-center h-[64px] max-h-full items-center',
						!params?.data?.isCreate && 'cursor-pointer',
					)
				}
				onClick={
					areSettingsAccessible
						? () => setMutatingClient({
							...params.data,
							node: params.node,
							api:  params.api,
						})
						: noop
				}
			>
				{
					areSettingsAccessible
						? (
							<div className="flex w-[16px] justify-center items-center"
								data-testid="accountSettings"
							>
								<SettingsInstanceIcon />
							</div>
						)
						: <NoValuePlaceholder />
				}
			</div>
			<div className='flex flex-1 h-full w-full items-center justify-center'>
				<SettingsBreakdownSelector
					{...params}
				/>
			</div>
		</DashboardCellRendererFrame>);
};

export default AdAccountSettingsCellRenderer;
